import { loginNoFunction, axios } from "../request/pcAxios"
import store from '../store'
class Home {
  // 刷新token，获取用户信息
  static refreshLoginData() {
    return loginNoFunction.get('/customer/public/customer/refreshLoginData')
  }
  // 获取头像
  static getFileImage (entId) {
    return axios.get('/customer/public/enterprise/getPortraitUrl', {params: {
      entId
    }})
  }
  // 设置头像
  static uploadPortrait (params, entId) {
    return axios.post('/customer/public/enterprise/uploadPortraitApplets', params, false, {
      entId
    })
  }
  // 粉丝数+关注数+草稿数+已铸造数+发售中数+持有许可作品数
  static getSubscribeCount () {
    const enterpriseId = store.state.enterpriseId
    return axios.post('/nft/public/subscribe/getSubscribeCount', { enterpriseId })
  }
  // 获取当前用户的权限
  static getNftPower () {
    return axios.get('/nft/public/art/cast/getNftPower')
  }
  // 获取他人主页信息
  static getOthersHomeInfo (enterpriseId) {
    return axios.post('/nft/public/subscribe/getOthersHomePageInfo', { enterpriseId })
  }
  // 获取他人主页在售作品信息
  static getOthersHomeWorksInfo (data) {
    return axios.post('/nft/public/subscribe/getOthersHomeWorksInfo', data)
  }
  // 他人主页已购作品列表
  static getArtSellRecordPageInfo (data) {
    return axios.post('/nft/public/seller/record/getArtSellRecordPageInfo', data)
  }
}

export default Home